import styled from 'styled-components'

import { helpers } from 'styles'

export const Caption = styled.div`
	font-size: 13px;
	color: ${helpers.color.textMuted};
	text-align: right;
`
